import React from 'react';
import { useEffect, useRef } from 'react';
// import { Button } from 'antd';
// import { DownOutlined } from '@ant-design/icons';
// import QueueAnim from 'rc-queue-anim';
// import TweenOne, { TweenOneGroup } from 'rc-tween-one';
// import BannerAnim, { Element } from 'rc-banner-anim';
// import { isImg } from './utils';
// import 'rc-banner-anim/assets/index.css';
import './less/canvas.less';
import { init } from '../js/particle.js'

const { BgElement } = Element;
// class Banner extends React.PureComponent {
//   render() {

//     return (
//       <div></div>
//     )
//     // const { ...props } = this.props;
//     // const { dataSource } = props;
//     // delete props.dataSource;
//     // delete props.isMobile;
//     // const childrenToRender = dataSource.BannerAnim.children.map((item, i) => {
//     //   const elem = item.BannerElement;
//     //   const elemClassName = elem.className;
//     //   delete elem.className;
//     //   const { bg, textWrapper, title, content, button } = item;
//     //   return (
//     //     <Element key={i.toString()} {...elem} prefixCls={elemClassName}>
//     //       <BgElement key="bg" {...bg} />
//     //       <QueueAnim
//     //         type={['bottom', 'top']}
//     //         delay={200}
//     //         key="text"
//     //         {...textWrapper}
//     //       >
//     //         <div key="logo" {...title}>
//     //           {typeof title.children === 'string' &&
//     //           title.children.match(isImg) ? (
//     //             <img src={title.children} width="100%" alt="img" />
//     //           ) : (
//     //             title.children
//     //           )}
//     //         </div>
//     //         <div key="content" {...content}>
//     //           {content.children}
//     //         </div>
//     //         <Button ghost key="button" {...button}>
//     //           {button.children}
//     //         </Button>
//     //       </QueueAnim>
//     //     </Element>
//     //   );
//     // });
//     // return (
//     //   <div {...props} {...dataSource.wrapper}>
//     //     <TweenOneGroup
//     //       key="bannerGroup"
//     //       enter={{ opacity: 0, type: 'from' }}
//     //       leave={{ opacity: 0 }}
//     //       component=""
//     //     >
//     //       <div className="banner1-wrapper" key="wrapper">
//     //         <BannerAnim key="BannerAnim" {...dataSource.BannerAnim}>
//     //           {childrenToRender}
//     //         </BannerAnim>
//     //       </div>
//     //     </TweenOneGroup>
//     //     <TweenOne
//     //       animation={{
//     //         y: '-=20',
//     //         yoyo: true,
//     //         repeat: -1,
//     //         duration: 1000,
//     //       }}
//     //       className="banner1-icon"
//     //       style={{ bottom: 40 }}
//     //       key="icon"
//     //     >
//     //       <DownOutlined />
//     //     </TweenOne>
//     //   </div>
//     // );
//   }
// }


const Banner = (props) => {
  const canvasRef = useRef(null);
  useEffect(() => {
    init(canvasRef.current)
    console.log(`初始化three`, canvasRef)
  }, [])
  const id = props.id;
  return (
    <div id={id} className="fc-animation-web">
      <div ref={canvasRef} className="animation-web webgl"></div>
      <section className="section">
        <div className="fc-title">中国数字化服务商可信赖的技术赋能者、创新者</div>
        <p className='fc-content'>
         我们源于工业，服务于工业。为千行百业提供数字化解决方案，助力企业智改数转、降本增效
        </p>
      </section>
      <section className="section">
        <div className="fc-title">数字孪生高速解决方案</div>
        <p className='fc-content'>
          数字孪生智慧高速通过运用数字孪生技术，实现了交通环境的静态空间还原和动态感知仿真，将静态和动态元素融合，以实现虚拟与现实的闭环运行，是智慧矿山系统的关键组成部分。
        </p>
      </section>
      <section className="section">
        <div className="fc-title">中国数字化服务商可信赖的技术赋能者、创新者</div>
        <p className='fc-content'>
         我们源于工业，服务于工业。为千行百业提供数字化解决方案，助力企业智改数转、降本增效
        </p>
      </section>
      <section className="section">
        <div className="fc-title">数字孪生高速解决方案</div>
        <p className='fc-content'>
          数字孪生智慧高速通过运用数字孪生技术，实现了交通环境的静态空间还原和动态感知仿真，将静态和动态元素融合，以实现虚拟与现实的闭环运行，是智慧矿山系统的关键组成部分。
        </p>
      </section>
    </div>
  )
}

export default Banner;
